module.exports = __webpack_public_path__ + "static/media/1009229.3e0a000b.png";